import classnames from 'classnames'
import * as React from 'react'

import {DMSize, InputType, RefProp} from '../types'
import styles from './styles.module.css'

export type TextareaInputSize = DMSize

export interface Props extends InputType<string> {
  size?: TextareaInputSize
}

/** This component used by itself is not accessible.
 * Please use the LabeledTextareaInput.
 */

const TextareaInput: React.FC<RefProp<HTMLTextAreaElement, Props>> = ({
  onChange,
  elementRef,
  placeholder = '',
  displayClasses,
  error = false,
  size,
  dataSeleniumTarget,
  ...props
}) => {
  const updateValue: React.ChangeEventHandler<HTMLTextAreaElement> = (ev) => {
    onChange(ev.target.value)
  }
  const classes = classnames(styles.input, displayClasses, size, {
    [`${styles.error}`]: error,
  })

  return (
    <textarea
      placeholder={placeholder}
      onChange={updateValue}
      ref={elementRef}
      className={classes}
      data-selenium-target={dataSeleniumTarget}
      {...props}
    />
  )
}

export default React.forwardRef<HTMLTextAreaElement, Props>((props, ref) => (
  <TextareaInput elementRef={ref} {...props} />
))
